import { fetchWithAuth } from './fetchWithAuth';

export const fetchGiftList = async (gift_year) => {
  return fetchWithAuth(`/gift?gift_year=${gift_year}`);
};

export const fetchGiftDetail = async (gift_year, seq_no) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}`);
};

export const fetchGiftListForApply = async (gift_year) => {
  return fetchWithAuth(`/gift/apply-list?gift_year=${gift_year}`);
};

export const createGift = async (form) => {
  return fetchWithAuth(`/gift`, { method: 'POST', body: JSON.stringify(form) });
};

export const updateGift = async (gift_year, seq_no, form) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

export const deleteGift = async (gift_year, seq_no) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}`, { method: 'DELETE' });
};

export const fetchGiftApplyList = async (gift_year, seq_no) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}/apply`);
};

export const applyGift = async (gift_year, seq_no, opt_no) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}/apply`, {
    method: 'POST', body: JSON.stringify({ opt_no }),
  });
};

export const cancelGift = async (gift_year, seq_no) => {
  return fetchWithAuth(`/gift/${gift_year}/${seq_no}/apply`, { method: 'DELETE' });
};